import React from 'react';

function CarsIcon({ w, h, className, childrenClassNames }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" w={w} h={h} className={className} viewBox="0 0 36 36">
      <path
        fillRule="nonzero"
        className={childrenClassNames.path}
        d="M7.2 19l1.543-3.857A5 5 0 0 1 13.385 12h9.23a5 5 0 0 1 4.642 3.143L28.8 19h2.7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.847A4.988 4.988 0 0 1 32 24.414V32a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H8v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7.586c0-1.313.509-2.517 1.347-3.414H4.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2.7zm2.005.374A99.576 99.576 0 0 1 18 19c3.056 0 5.988.125 8.795.374L25.4 15.886A3 3 0 0 0 22.615 14h-9.23a3 3 0 0 0-2.785 1.886l-1.395 3.488zM8 22a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm20 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-15 5a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H13z"
      />
    </svg>
  );
}

CarsIcon.defaultProps = {
  w: 16,
  h: 16,
  childrenClassNames: {},
};

export default CarsIcon;
